import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class FlightReportsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_id: null,
      base_id: null,
      contract_id: null,
      client_id: null,
      flight_type_id: null,
      date: null,
      flight_number: null,
      report_number: null,
      staff_sigmec_id: null,
      exemption: 0,
      power_checks: 0,
      observations: null,
      bases_select: [],
      aircrafts_select: [],
      flight_types_select: [],
      contracts_select: [],
      show_select_clients: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectFlightTypeChange(name, event) {
    var change = {};
    var self = this;
    change['flight_type_id'] = null;
    change['client_id'] = null;
    change['show_select_clients'] = null;
    if(event == null) {
      change[name] = null;
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/tipo/voo/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.data.client_required === 1) {
            self.setState({
              show_select_clients: true,
            });
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }); /* Overlay */
      });
    }
    this.setState(change);
  }
  handleSelectAircraftChange(name, event) {
    var change = {};
    var self = this;
    change['contract_id'] = null;
    if(event == null) {
      change[name] = null;
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/contrato/aeronave/select/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.setState({
              contracts_select: responseJson.data,
            });
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }); /* Overlay */
      });
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorio/voo/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/relatorios/voo');
        if (responseJson.status === 'success') {
          const staffs_sigmec_select = responseJson.data.staffs_sigmec_select || responseJson.data.staff_mechanics_select || [];
          self.setState({
            bases_select: responseJson.data.bases_select,
            aircrafts_select: responseJson.data.aircrafts_select,
            clients_select: responseJson.data.clients_select,
            flight_types_select: responseJson.data.flight_types_select,
            staffs_sigmec_select: staffs_sigmec_select,
            date: responseJson.data.date,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      origin: 'Manual',
      client_id: this.state.client_id,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      contract_id: this.state.contract_id,
      flight_type_id: this.state.flight_type_id,
      date: this.state.date,
      flight_number: this.state.flight_number,
      power_checks: this.state.power_checks,
      report_number: this.state.report_number,
      exemption: this.state.exemption,
      staff_sigmec_id: this.state.staff_sigmec_id,
      observations: this.state.observations,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/relatorio/voo/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.titulo}</h3>
      <Link to="/relatorios/voo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Data}:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" required />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Prefixo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectAircraftChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Voo}:</label>
              <Select
                className="form-field-name"
                name="flight_type_id"
                value={this.state.flight_type_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectFlightTypeChange.bind(this, 'flight_type_id')}
                options={this.state.flight_types_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.NumeroDeVoo}:</label>
              <input type="text" name="flight_number" className="form-control" placeholder="" value={this.state.flight_number} onChange={this.handleChange.bind(this, 'flight_number')} />
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.SolicitouIsencao}</label>
              <br/>
              <Toggle
                checked={this.state.exemption}
                aria-label='No label tag'
                name="exemption"
                onChange={this.handleToggleChange.bind(this, 'exemption')}
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.PowerCheck}</label>
              <br/>
              <Toggle
                checked={this.state.power_checks}
                aria-label='No label tag'
                name="power_checks"
                onChange={this.handleToggleChange.bind(this, 'power_checks')}
              />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Base}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Contrato}:</label>
              <Select
                className="form-field-name"
                name="contract_id"
                value={this.state.contract_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'contract_id')}
                options={this.state.contracts_select}
                required
              />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.NumeroDoRelatorio}:</label>
              <input type="text" name="report_number" className="form-control" placeholder="" value={this.state.report_number} onChange={this.handleChange.bind(this, 'report_number')} required />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.MecanicoResponsavel}:</label>
              <Select
                className="form-field-name"
                name="staff_sigmec_id"
                value={this.state.staff_sigmec_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'staff_sigmec_id')}
                options={this.state.staffs_sigmec_select}
              />
          </div>
        </div>
        {(this.state.show_select_clients == true) &&
          <div className="row">
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Cliente}</label>
              <Select
                className="form-field-name"
                name="client_id"
                value={this.state.client_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'client_id')}
                options={this.state.clients_select}
                required
              />
            </div>
          </div>
        }
        <div className="form-group">
          <label>{this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Observacoes}:</label>
          <textarea style={{ height: 100 }} type="text" name="observations" className="form-control" placeholder="" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.botaoCriarRelatorioDeVoo}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportsAdd;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/FlightReportsAdd.js